'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = accessors;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _ramda = require('ramda');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTimeX = function getTimeX(datum) {
  return (0, _ramda.is)(String, datum.x) ? new Date(datum.x) : datum.x;
};

function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    x: getTimeX,
    xTicks: function xTicks(_, axis) {
      return axis.xAxis.scale().ticks();
    },
    isCondensed: function isCondensed(options, serie, scale) {
      // fastest way to handle x accessor override is to duplicate here
      var datapoints = target.accessors.datapoints(serie);
      var datapointsCount = (0, _ramda.length)(datapoints);
      var datapointsXPositions = (0, _ramda.map)(function (dp) {
        return scale(getTimeX(dp));
      }, datapoints);
      var datapointsXExtent = _d2.default.extent(datapointsXPositions);
      var rangeDelta = (0, _utils.getRangeDelta)(datapointsXExtent);
      var ratio = rangeDelta / (0, _ramda.max)(1, datapointsCount);
      return ratio < options.line.densityRatio;
    }
  });
}